import { render, staticRenderFns } from "./deworming.vue?vue&type=template&id=9da9a98c&scoped=true&"
import script from "./deworming.vue?vue&type=script&lang=js&"
export * from "./deworming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da9a98c",
  null
  
)

export default component.exports